import dynamic from 'next/dynamic';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { getHeaders } from '../../../../utils';
import {
  getProfilePublicId,
  getUserPublicId,
} from '../../../../utils/authUtils';
import { instance } from '../../../axios/axios';
import {
  getCurrentUserRegistered,
  setPsychoQuizModal,
  setQuizModal,
} from '../../../store/slices/community/loveSlice';
import OutsideAlerter from '../../Common/OutsideAlerter/OutsideAlerter';
import FilterView from './FilterView';
import MobileFilterView from './MobileFilterView';
import QuizModal from './QuizModal';
import TakeQuizModal from './TakeQuizModal';

const MdExpandLess = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdExpandLess)
);
const MdExpandMore = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdExpandMore)
);

async function showAlert(lang) {
  return Swal.fire({
    text: lang?.community?.are_you_sure_you_want_to_delete_your_answers,
    icon: 'warning',
    iconColor: '#000',
    showCancelButton: true,
    confirmButtonColor: '#000',
    confirmButtonText: lang?.market?.yes,
    cancelButtonText: lang?.common?.cancel,
  });
}

async function showSuccess(lang) {
  Swal.fire({
    icon: 'success',
    iconColor: '#000',
    title: lang?.common?.success,
    text: lang?.community?.your_quiz_has_been_cleared,
    timer: 2000,
    showConfirmButton: false,
  });
}

const SortView = () => {
  const lang = useSelector(({ common }) => common?.language);
  const dispatch = useDispatch();

  const [showLocal, setShowLocal] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const loveProfile = useSelector(({ love }) => love?.isCurrentUserRegistered);

  const handleLocalTakeQuizAgain = async () => {
    dispatch(setQuizModal(true));
  };

  const handleAllCityTakeQuizAgain = async () => {
    dispatch(setPsychoQuizModal(true));
  };

  const handleClear = (quizType) => {
    try {
      showAlert(lang).then(async (result) => {
        if (result.isConfirmed) {
          const res = await instance.delete(
            `/forum/love/clear/${loveProfile?.user_id}?profile_id=${loveProfile?.profile_id}&quiz_type=${quizType}`,
            getHeaders()
          );
          if (res?.status === 200) {
            // dispatch(getPreferredUsers());
            dispatch(
              getCurrentUserRegistered({
                user_id: getUserPublicId(),
                profile_id: getProfilePublicId(),
              })
            );
            showSuccess(lang);
          }
        }
      });
    } catch (error) {
      console.error('Something went wrong', error);
    }
  };

  const handleLocalDropdown = () => {
    setShowLocal(!showLocal);
  };

  const handleAllDropdown = () => {
    setShowAll(!showAll);
  };

  const width = window?.innerWidth;

  return (
    <div className='flex w-full items-center justify-between'>
      {width > 600 && (
        <div className='flex justify-center gap-2'>
          <FilterView />
        </div>
      )}
      {width < 600 && (
        <div className='mr-2 sm:hidden'>
          <MobileFilterView />
        </div>
      )}
      <div className='flex items-center gap-1 pr-2 sm:gap-3'>
        <span className='hidden text-sm font-bold sm:block'>
          {lang?.common?.quiz}:{' '}
        </span>
        <div className='flex cursor-pointer gap-1 text-sm sm:gap-3'>
          {/* <div>Quiz: </div> */}
          <OutsideAlerter outsideClickHandler={setShowLocal}>
            <div
              onClick={handleLocalDropdown}
              className='relative flex w-[120px] items-center justify-between rounded-[40px] border px-[16px] py-[8px] text-xs font-bold sm:w-[154px] sm:text-sm'
            >
              {lang?.community?.local_quiz}
              <div>{showLocal ? <MdExpandLess /> : <MdExpandMore />}</div>
            </div>

            {showLocal && (
              <ul className='absolute z-10 ml-[5px] mt-[10px] w-[120px]  cursor-pointer bg-white py-[16px] font-medium shadow-lg sm:w-[154px]'>
                <li
                  onClick={handleLocalTakeQuizAgain}
                  className=' flex py-2 hover:bg-gray-100'
                >
                  <span className='px-4 font-semibold'>
                    {loveProfile?.generic_quiz?.length > 0
                      ? lang?.community?.retake_quiz
                      : lang?.community?.take_quiz}
                  </span>
                </li>
                {loveProfile?.generic_quiz?.length > 0 ? (
                  <li
                    onClick={() => handleClear('local')}
                    className='flex py-2 hover:bg-gray-100'
                  >
                    <span className='px-4 font-semibold'>
                      {lang?.community?.clear_quiz}
                    </span>
                  </li>
                ) : null}
              </ul>
            )}
          </OutsideAlerter>
          <OutsideAlerter outsideClickHandler={setShowAll}>
            <div
              onClick={handleAllDropdown}
              className='relative flex w-[100px] items-center justify-between truncate rounded-[40px] border px-[16px] py-[8px] text-xs font-bold capitalize sm:w-[154px] sm:text-sm'
            >
              {lang?.community?.all_city_quiz}{' '}
              <div>{showAll ? <MdExpandLess /> : <MdExpandMore />}</div>
            </div>
            {showAll && (
              <ul className='absolute z-10 mr-[10px] mt-[10px]  w-[120px] cursor-pointer bg-white py-[16px] font-medium uppercase shadow-lg sm:w-[154px]'>
                <li
                  onClick={handleAllCityTakeQuizAgain}
                  className=' flex py-2 hover:bg-gray-100'
                >
                  <span className='px-4 font-semibold'>
                    {loveProfile?.psychometric_quiz?.length > 0
                      ? lang?.community?.retake_quiz
                      : lang?.community?.take_quiz}
                  </span>
                </li>
                {loveProfile?.psychometric_quiz?.length > 0 ? (
                  <li
                    onClick={() => handleClear('all_city')}
                    className=' flex py-2 hover:bg-gray-100'
                  >
                    <span className='px-4 font-semibold'>
                      {lang?.community?.clear_quiz}
                    </span>
                  </li>
                ) : null}
              </ul>
            )}
          </OutsideAlerter>
        </div>
      </div>

      <TakeQuizModal />
      <QuizModal />
    </div>
  );
};

export default SortView;
